import { ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableElfProdMode } from '@ngneat/elf';
import { devTools } from '@ngneat/elf-devtools';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import * as envStaging from '@env/environment.staging';

import * as Sentry from '@sentry/angular';

// Determine the current subdomain
const hostname = window.location.hostname;
// const isStagingOrDevelop = hostname.includes('staging') || hostname.includes('develop');
const isStaging = hostname.includes('staging');

if (envStaging.environment.isSentry && isStaging) {
  Sentry.init({
    dsn: envStaging.environment.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    // debug: true,
    allowUrls: [/https?:\/\/((cdn|www|develop|staging)\.)?cogwheelanalytics\.com/],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/https?:\/\/((cdn|www|develop|staging)\.)?cogwheelanalytics\.com/], // Allow trace propagation for these subdomains
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // profilesSampleRate: 1.0, // Capture 100% of the profiles of all transactions and 0 will profile none.
  });
}

type DataLayerItem = Record<string, unknown> | [string, ...unknown[]];

declare global {
  interface Window {
    dataLayer: DataLayerItem[];
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    if (environment.production) {
      enableElfProdMode();
    } else {
      devTools({
        postTimelineUpdate: () => moduleRef.injector.get(ApplicationRef).tick(),
      });
    }
  })
  .catch((err) => console.error(err));
